import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "react-select/lib/filters";
import useGetCurriculumOptions from "@modules/shared/selectors/hooks/useGetCurriculumOptions";
import AdvanceSelector from "../advance-selector";

interface AdvancedCurriculumSelectorProps {
  activeCode?: boolean;
  campusId?: string;
  departmentId?: string;
  modalityId?: string;
  curriculumOption?: Option;
  onChange?: (option: Option) => void;
  programId?: string;
  scenario: string;
  shiftId?: string;
}

const AdvancedCurriculumSelector = ({
  scenario,
  onChange,
  curriculumOption,
  ...filters
}: AdvancedCurriculumSelectorProps) => {
  const [value, setValue] = useState(curriculumOption);

  const { loadCurriculumOptions } = useGetCurriculumOptions({
    scenario,
    ...filters,
  });

  const { t } = useTranslation();

  return (
    <AdvanceSelector
      isPaginated
      dimension={t("advanced-search.instructor.forms.select-wrapper.curriculum.label")}
      selectPlaceholder={t(
        "advanced-search.instructor.forms.select-wrapper.curriculum.placeholder",
      )}
      loadOptions={loadCurriculumOptions}
      value={value}
      onChange={option => {
        setValue(option);
        onChange?.(option);
      }}
      notShowLabel
    />
  );
};

export default AdvancedCurriculumSelector;
